import { IconButton } from '../IconButton';
/**
 * __Profile__
 *
 * A profile button which takes an icon/avatar component can be that can be
 * passed into `AtlassianNavigation`'s `renderProfile` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#profile)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var Profile = IconButton;

// This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
export default (function (props) {});